var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    height: "40px",
    width: "40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7,2.7c-3.7,0-7.3,1.1-10.4,3.2c-3.1,2-5.5,4.9-6.9,8.4C0,17.6-0.4,21.4,0.4,25c0.7,3.6,2.5,6.9,5.1,9.6 c2.7,2.7,6,4.4,9.6,5.1c3.6,0.7,7.3,0.4,10.8-1.1c3.5-1.5,6.3-3.9,8.4-6.9c2-3.1,3.2-6.7,3.2-10.4H18.7V2.7z M34.8,23.8 c-0.3,2.4-1.2,4.7-2.5,6.7c-1.9,2.7-4.4,4.8-7.3,6c-2.9,1.2-6.3,1.6-9.5,0.9s-6.1-2.1-8.4-4.5c-2.3-2.3-3.9-5.2-4.5-8.4 C1.9,21.2,2.3,18,3.5,15c1.2-3.1,3.3-5.5,6-7.3c2-1.3,4.4-2.3,6.8-2.5v16.3c0,1.3,1.1,2.4,2.4,2.4H34.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5,5.5C31.1,2,26.3,0,21.3,0v18.7H40C40,13.8,38,9,34.5,5.5z M23.7,16.3V2.6c3.5,0.5,6.7,2.1,9.2,4.7 c2.5,2.5,4.1,5.7,4.7,9.2H23.7V16.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f184fe4c.svg";
export { ForwardRef as ReactComponent };